import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { Component, useState } from 'react';
import parse from 'html-react-parser';

import { Avatar, Grid, Stack } from '@mui/material';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { IDiscussionResponse } from 'redux/reducers/user/dashboard/tms-discussion';

const CommentHeader = ({ data }: { data: IDiscussionResponse }) => {
  return (
    <Box m={2}>
      <Stack
        direction="row"
        justifyContent="flex-start"
        p={1}
        sx={{
          backgroundColor: 'white',
          height: 1
        }}
        spacing={1}
      >
        <Avatar alt={data.user.email} src={data.user.profile ?? ''} />
        <Box>
          <Typography
            sx={{
              fontSize: '15px'
            }}
          >
            {data.user.email}
          </Typography>
          <Typography
            sx={{
              fontSize: '10px'
            }}
          >
            {data.posted}
          </Typography>
        </Box>
      </Stack>

      <Typography
        style={{ marginLeft: 1, width: '600px' }}
        dangerouslySetInnerHTML={{ __html: data?.content }}
      ></Typography>

      {data?.attachment.url ? (
        <Stack>
          <a href={data.attachment.url}>
            <Grid container sx={{ paddingTop: '10px' }}>
              <Grid item xs={1}>
                <Box
                  sx={{
                    height: '100%',
                    width: '50px',
                    display: 'flex',
                    justifyContent: 'end'
                  }}
                >
                  <FileIcon extension={data.attachment.type} />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                display={'flex'}
                alignItems={'end'}
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    width: '100px',
                    color: '#000'
                  }}
                >
                  {data.attachment.name}
                </Typography>
              </Grid>
            </Grid>
          </a>
        </Stack>
      ) : (
        ''
      )}
    </Box>
  );
};

export default CommentHeader;
